import { Box, Button, Container, Grid, Typography } from "@mui/material";
import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

const Pricing = () => {
  return (
    <div className="pricing-section">
      <Container sx={{ py: 6 }}>
        <Box sx={{ textAlign: "center", color: "#fff" }}>
          <Typography
            sx={{ fontSize: 14, textTransform: "uppercase", mb: 2 }}
            variant="subtitle1"
          >
            Whats the function
          </Typography>
          <Typography className="section-title" variant="h3">
            Let’s see how it works
          </Typography>
        </Box>
        <Box sx={{ flexGrow: 1, mt: 8 }}>
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 2, sm: 8, md: 12 }}
            sx={{ textAlign: { xs: "center", md: "left" } }}
          >
            <Grid item xs={2} sm={4} md={2}></Grid>
            <Grid item xs={2} sm={4} md={4}>
              <Box
                sx={{
                  bgcolor: "#2F5392",
                  color: "#fff",
                  borderRadius: 4,
                  boxShadow: 1,
                  px: 4,
                  py: 8,
                  height: 1,
                }}
              >
                <Box>
                  <Typography
                    sx={{ fontSize: 22, fontWeight: 700, mb: 2 }}
                    variant="h4"
                  >
                    Free Plan
                  </Typography>
                  <Typography
                    sx={{ fontSize: 15, color: "rgba(255,255,255,0.65)" }}
                    variant="body1"
                  >
                    For Small teams or office
                  </Typography>
                </Box>
                <Box
                  sx={{
                    my: 4,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2,
                      alignItems: "center",
                      my: 2,
                    }}
                  >
                    <CheckCircleIcon sx={{ color: "#3FDBB1" }} />
                    <Typography variant="body2">
                      Ultimate access to all course, exercises and assessments
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2,
                      alignItems: "center",
                      my: 2,
                    }}
                  >
                    <CheckCircleIcon sx={{ color: "#3FDBB1" }} />
                    <Typography variant="body2">
                      Free acess for all kind of exercise corrections with
                      downloads.
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2,
                      alignItems: "center",
                      my: 2,
                    }}
                  >
                    <CheckCircleIcon sx={{ color: "#3FDBB1" }} />
                    <Typography variant="body2">
                      Total assessment corrections with free download access
                      system
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2,
                      alignItems: "center",
                      my: 2,
                    }}
                  >
                    <HighlightOffIcon sx={{ color: "#6d86b2" }} />
                    <Typography
                      sx={{ color: "rgba(255,255,255,0.55)" }}
                      variant="body2"
                    >
                      Unlimited download of courses on the mobile app contents
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2,
                      alignItems: "center",
                      my: 2,
                    }}
                  >
                    <HighlightOffIcon sx={{ color: "#6d86b2" }} />
                    <Typography
                      sx={{ color: "rgba(255,255,255,0.55)" }}
                      variant="body2"
                    >
                      Download and print courses and exercises in PDF
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ textAlign: "center", mt: 6 }}>
                  <Button
                    sx={{
                      borderRadius: 50,
                      color: "#2F5392",
                      textTransform: "inherit",
                    }}
                    color="info"
                    variant="contained"
                  >
                    Signup Now
                  </Button>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <Box
                sx={{
                  bgcolor: "#fff",
                  borderRadius: 4,
                  boxShadow: 1,
                  px: 4,
                  pb: 8,
                  pt: 3,
                  height: 1,
                }}
              >
                <Box>
                  <Button
                    sx={{
                      textTransform: "inherit",
                      bgcolor: "#EF9E48",
                      color: "#fff",
                      mb: 1,
                    }}
                    variant="contained"
                  >
                    Recommended
                  </Button>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Box>
                    <Typography
                      sx={{ fontSize: 22, fontWeight: 700, mb: 2 }}
                      variant="h4"
                    >
                      Premium
                    </Typography>
                    <Typography sx={{ fontSize: 15 }} variant="body1">
                      For startup enterprise
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      sx={{ fontSize: 16, fontWeight: 400, mb: 2 }}
                      variant="h5"
                    >
                      Starting from
                    </Typography>
                    <Typography
                      sx={{ fontSize: 26, fontWeight: 700, color: "#25CB9E" }}
                      variant="h4"
                    >
                      49.99/mo
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    my: 4,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2,
                      alignItems: "center",
                      my: 2,
                    }}
                  >
                    <CheckCircleIcon sx={{ color: "#3FDBB1" }} />
                    <Typography variant="body2">
                      Ultimate access to all course, exercises and assessments
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2,
                      alignItems: "center",
                      my: 2,
                    }}
                  >
                    <CheckCircleIcon sx={{ color: "#3FDBB1" }} />
                    <Typography variant="body2">
                      Free acess for all kind of exercise corrections with
                      downloads.
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2,
                      alignItems: "center",
                      my: 2,
                    }}
                  >
                    <CheckCircleIcon sx={{ color: "#3FDBB1" }} />
                    <Typography variant="body2">
                      Total assessment corrections with free download access
                      system
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2,
                      alignItems: "center",
                      my: 2,
                    }}
                  >
                    <CheckCircleIcon sx={{ color: "#3FDBB1" }} />
                    <Typography variant="body2">
                      Unlimited download of courses on the mobile app contents
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2,
                      alignItems: "center",
                      my: 2,
                    }}
                  >
                    <CheckCircleIcon sx={{ color: "#3FDBB1" }} />
                    <Typography variant="body2">
                      Download and print courses and exercises in PDF
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ textAlign: "center", mt: 6 }}>
                  <Button
                    sx={{
                      borderRadius: 50,
                      textTransform: "inherit",
                    }}
                    color="primary"
                    variant="contained"
                  >
                    Signup Now
                  </Button>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={2} sm={4} md={2}></Grid>
          </Grid>
        </Box>
      </Container>
    </div>
  );
};

export default Pricing;
